import { useState } from 'react';
import styled from 'styled-components';
import { translations } from '../../locales/translations';
import firstgate from '../../assets/firstgate.webp';
import bskinvestment from '../../assets/bsk-investment.webp';
import tips from '../../assets/tips.webp';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Title = styled.h2`
  color: white;
  font-size: 2.5rem;
  margin-bottom: 50px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

const LogoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 800px;
  width: 100%;
  padding: 20px;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  height: 100px;
  transition: transform 0.3s ease;
  width: 100%;
  position: relative;
`;

const Logo = styled.img`
  height: 100%;
  width: auto;
  object-fit: contain;
  max-width: 80%;
  opacity: ${(props) => (props.$loaded ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  position: absolute;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const partners = [
  { id: 1, image: firstgate, name: 'Firstgate' },
  { id: 2, image: bskinvestment, name: 'BSK Investment' },
  { id: 3, image: tips, name: 'TIPS' },
];

function PartnersTab({ currentLang }) {
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <Container>
      <Title>{translations[currentLang].partners}</Title>
      <LogoGrid>
        {partners.map((partner) => (
          <LogoContainer key={partner.id}>
            {!loadedImages[partner.id] && <Spinner />}
            <Logo
              src={partner.image}
              alt={partner.name}
              draggable="false"
              onLoad={() => handleImageLoad(partner.id)}
              $loaded={loadedImages[partner.id]}
            />
          </LogoContainer>
        ))}
      </LogoGrid>
    </Container>
  );
}

export default PartnersTab;
